var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7998 2.5015C11.9749 2.32641 12.1828 2.18751 12.4115 2.09275C12.6403 1.99799 12.8855 1.94922 13.1331 1.94922C13.3808 1.94922 13.626 1.99799 13.8547 2.09275C14.0835 2.18751 14.2914 2.32641 14.4665 2.5015C14.6416 2.6766 14.7805 2.88447 14.8752 3.11324C14.97 3.34202 15.0188 3.58721 15.0188 3.83484C15.0188 4.08246 14.97 4.32766 14.8752 4.55643C14.7805 4.78521 14.6416 4.99307 14.4665 5.16817L5.46647 14.1682L1.7998 15.1682L2.7998 11.5015L11.7998 2.5015Z",
    stroke: "#40C5E8",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit-2.41f229f6a78608b48192c4ead494046b.svg";
export { ForwardRef as ReactComponent };